module.exports = __webpack_public_path__ + "static/img/quieromisdatos-2.f4a2f17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/quieromisdatos-2.jpg
// module id = RjxR
// module chunks = 1